import React from 'react';
import './EmptyState.css';

/**
 * EmptyState — shown when a list/view has no data.
 *
 * Props:
 *   icon        — emoji or string (default: '📭')
 *   title       — short heading
 *   description — optional subtitle
 *   action      — { label, onClick } or { label, href }
 *   size        — 'sm' | 'md' (default) | 'lg'
 */
export default function EmptyState({ icon = '📭', title, description, action, size = 'md' }) {
  return (
    <div className={`es-root es-${size}`}>
      <div className="es-icon">{icon}</div>
      {title && <div className="es-title">{title}</div>}
      {description && <div className="es-desc">{description}</div>}
      {action && (
        action.href
          ? <a href={action.href} className="es-btn">{action.label}</a>
          : <button onClick={action.onClick} className="es-btn">{action.label}</button>
      )}
    </div>
  );
}
